"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import Image from "next/image";
import norderg from "@/assets/backgroundVectors/norderg.png";
import familjenNordbergMobileBgVector from "@/assets/backgroundVectors/familjenNordbergMobileBgVector.png";

export default function OwnerCard3({
  name,
  shortDescription,
  fullDescriptionParaOne,
  fullDescriptionParaTwo,
  image,
  bgColor
}) {
  const t = useTranslations();
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className="relative rounded-3xl overflow-visible"
      style={{ backgroundColor: bgColor || "#B3D1E3" }}
    >
      <Image
        src={norderg}
        alt="norderg background vector"
        className="hidden md:block absolute top-0 right-0 md:w-[38%] z-0 [@media(min-width:2400)]:w-100"
        loading="lazy"
      />
      <Image
        src={familjenNordbergMobileBgVector}
        alt="norderg background vector"
        className="md:hidden absolute left-0 bottom-[7%] w-[55%] z-0"
        loading="lazy"
      />
      <div className="flex flex-col md:flex-row items-end">
        {/* Text content */}
        <div
          className={`flex flex-col gap-4 pl-[9%] pr-[9%] pb-0 pt-10  md:pt-15 ${isExpanded ? "md:pb-15" : "md:pb-30"} md:w-[55%] z-10 transition-all duration-500`}
        >
          <h3 className="heading-micro-text text-ff-purple">{name}</h3>
          <p className="body-small-copy-text text-ff-purple">{shortDescription}</p>
          <div
            className="grid transition-[grid-template-rows] duration-500 ease-in-out"
            style={{ gridTemplateRows: isExpanded ? "1fr" : "0fr" }}
          >
            <div className="overflow-hidden">
              <div className="flex flex-col gap-4">
                <p className="body-small-copy-text text-ff-purple">{fullDescriptionParaOne}</p>
                <p className="body-small-copy-text text-ff-purple">{fullDescriptionParaTwo}</p>
              </div>
            </div>
          </div>
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-ff-purple body-small-copy-text underline self-start cursor-pointer"
          >
            {isExpanded ? t("owners.read_less") : t("owners.read_more")}
          </button>
        </div>

        {/* Image */}
        {image && (
          <div className="hidden md:block md:w-[45%] relative self-stretch md:right-[10%]">
            <Image
              src={image}
              alt={name}
              width={600}
              height={500}
              unoptimized
              className={`absolute bottom-0 right-0 object-contain object-bottom ${
                isExpanded ? "w-[87%] h-[82%]" : "w-full h-[115%]"
              } transition-all duration-500`}
            />
          </div>
        )}
      </div>

      {/* Mobile image - below text, aligned to the right per design */}
      {image && (
        <div className="md:hidden flex justify-end">
          <Image
            src={image}
            alt={name}
            width={400}
            height={350}
            unoptimized
            className="w-[80%] relative rounded-br-3xl"
          />
        </div>
      )}
    </div>
  );
}
